<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>SE CONNECTER</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>SE CONNECTER</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="login-area pt-5">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <!-- Formulaire de connexion -->
            <div class="col-lg-5 col-md-6">
                <div class="login-page">
                    <div class="form">
                        <!-- En-tête du formulaire -->
                        <div class="form-header">
                            <div class="icon-wrapper">
                                <i class="icofont-user"></i>
                            </div>
                            <h2>Connexion</h2>
                            <p>Connectez-vous à votre compte QUALIFPME</p>
                        </div>

                        <form
                            class="login-form"
                            [formGroup]="form"
                            (ngSubmit)="onSubmit()"
                        >
                            <div class="form-group text-start">
                                <label for="username">Adresse électronique</label>
                                <input
                                    class="form-control"
                                    type="email"
                                    id="username"
                                    formControlName="username"
                                    placeholder="Saisissez votre email"
                                />
                            </div>

                            <div class="form-group text-start">
                                <label for="password">Mot de passe</label>
                                <div class="password-input-wrapper">
                                    <input
                                        type="password"
                                        class="form-control"
                                        id="password"
                                        placeholder="Saisissez votre mot de passe"
                                        formControlName="password"
                                        [type]="showPassword ? 'text' : 'password'"
                                    />
                                    <button 
                                        type="button" 
                                        class="password-toggle-btn"
                                        (click)="togglePassword()"
                                        [attr.aria-label]="showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'"
                                    >
                                        <i [class]="showPassword ? 'icofont-eye-blocked' : 'icofont-eye'"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group text-end">
                                <a class="text-default" routerLink="/forgot-password">Mot de passe oublié?</a>
                            </div>

                            <re-captcha
                                class="w-100"
                                id="recaptcha"
                                formControlName="recaptcha"
                            ></re-captcha>

                            <button class="btn btn-main" [disabled]="form.invalid || loading">
                                <span *ngIf="!loading">CONNEXION</span>
                                <span *ngIf="loading">CONNEXION EN COURS...</span>
                                <i *ngIf="loading" class="icofont-spinner-alt-1 icofont-spin"></i>
                            </button>
                            
                            <p class="message">
                                N'avez-vous pas encore de compte?
                                <a class="text-default" routerLink="/create-account">S'enregistrer ici</a>
                            </p>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Image à droite -->
            <div class="col-lg-6 col-md-6 d-none d-md-block">
                <div class="login-image">
                    <div class="image-wrapper">
                        <img src="assets/img/login-illustration.svg" alt="Connexion QUALIFPME" class="login-illustration">
                        <!-- <div class="image-overlay">
                            <h3>Bienvenue sur QUALIFPME</h3>
                            <p>La plateforme de labellisation des PME/PMI</p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <app-loading [loading]="loading" /> -->
